import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { reportError } from 'utils/error'
import { NounProjectResponse } from 'components/Design/ElementsTab/components/NounProjectResponseType'
import { useQuery } from 'react-query'

export const useNounProjectIcons = ({ query }: { query: string }) => {
  return useQuery(
    ['nounProjectIcons', query],
    async () => {
      const term = query.length > 0 ? query : 'icon'
      const response = await sendToApi<NounProjectResponse>(`/noun-project/icons?term=${term}`)

      if (response.type !== SUCCESS_RESPONSE_TYPE) {
        reportError(response, { severity: 'error' })
        return
      }

      // Filter out icons with no tags, as they've likely been deleted
      return response.data.icons.filter((icon) => icon.tags.length > 0)
    },
    {
      enabled: true,
      retry: false,
      retryOnMount: false,
      refetchOnWindowFocus: false,
      cacheTime: 1000 * 60 * 5,
    },
  )
}
